import { useMediaQuery } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { theme } from "config/theme";
import { NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import React from "react";

const useStyles = makeStyles<Theme, { step?: number }>(() => {
  return createStyles({
    root: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      flexDirection: "row",
      height: "100%",
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      paddingTop: "60px",
    },
    root1: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      width: "auto",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
    },
    left: {
      width: ({ step }) => (step === 3 || theme.breakpoints.down("xs") ? "70%" : "67%"),
      margin: "15px",
      [theme.breakpoints.down("xs")]: {
        margin: "0px",
        padding: "0px 5px",
        width: "100% !important",
      },
    },
    right: {
      width: "33%",
      backgroundColor: "#ffffff",
      padding: "20px",
    },
  });
});

interface WithSelectionProps {
  leftComponent: React.ReactElement | React.ReactNode;
  rightComponent: React.ReactElement | React.ReactNode;
}
export default function WithSection({ rightComponent, leftComponent }: WithSelectionProps) {
  const { step } = React.useContext(NewRequestQuoteContext);
  const styles = useStyles({ step });
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <div className={isSmallScreen ? styles.root1 : styles.root}>
      <div className={styles.left}>{leftComponent}</div>
      {!isSmallScreen && <div className={styles.right}>{rightComponent}</div>}
    </div>
  );
}
